import { z } from 'zod'
import { accountingIntegrations, publicApiIntegrations } from '@omnea-app/config/globalIntegrations'

export const SupplierRemoteTypeSchema = z.enum([...accountingIntegrations, ...publicApiIntegrations])
export type SupplierRemoteType = z.infer<typeof SupplierRemoteTypeSchema>

const RemoteInfoSchema = z.object({
  id: z.string().nullable(),
  link: z.string().nullable(),
  type: SupplierRemoteTypeSchema.nullable(),
})

const ProfileSchema = z.object({
  subsidiaryId: z.string().uuid(),
  remoteId: z.string().nullable(),
  remoteLink: z.string().nullable(),
})

const OrganisationSupplier = z.object({
  id: z.string().uuid(),
  name: z.string(),
  logoUrl: z.string().nullable(),
  remoteInfo: RemoteInfoSchema.nullable(),
  state: z.enum(['ACTIVE', 'ARCHIVED', 'INACTIVE', 'PENDING']),
  subsidiaries: z.array(z.string().uuid()),
  publicId: z.number(),
  profiles: z.array(ProfileSchema),
})

export const RequestSupplierSchema = OrganisationSupplier.describe(
  'The supplier for the request. fields on the supplier refer to state of the supplier within the request rather than the global supplier'
)
export type RequestSupplier = z.infer<typeof RequestSupplierSchema>
